// extracted by mini-css-extract-plugin
export default {"c-input":"input_c-input__674bf"};